import { getPath } from '@/router/common'

const baseUrl = {
  title: '协议',
  path: 'Notice'
}

export default [
  {
    path: getPath('CommonAgree', baseUrl),
    name: 'CommonAgree',
    component: () =>
      import(
        /* webpackChunkName: "CommonAgree" */ '@/views/notice/commonAgree/index.vue'
      ),
    meta: {
      title: '协议'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'Notice_Index',
    component: () => import(/* webpackChunkName: "Notice_Index" */ '@/views/notice/index/index.vue'),
    meta: {
      title: '公告列表'
    }
  },
  {
    path: getPath('DialogNotice', baseUrl),
    name: 'Notice_DialogNotice',
    component: () => import(/* webpackChunkName: "Notice_DialogNotice" */ '@/views/notice/dialogNotice/index.vue'),
    meta: {
      title: '新增修改公告通知'
    }
  }
]
